import ExerciseCardAPI from '@/apis/business/teacher/exercise-card-api.js'
import DashboardAPI from '@/apis/business/teacher/dashboard-api.js'
import StudentExerciseAPI from '@/apis/business/teacher/student-exercise-api.js'
import Enumeration from '@/common/enumeration.js'

export default {
  namespaced: true,
  state: {
    studentExercises: [],
    studentExercise: {},
    submitExercise: {}, // param lưu kết quả nộp bài
    selectedQuestion: {},
    exerciseCard: {},
    exercisesStores: [],
    countExercise: {},
    fileInfomation: {},
    tabActive: 0,
    tabActiveClassroom: 0,
    exerciseSaveDraft: '', // ID của bản ghi bài tập lưu nháp
    isReplay: true, // Học sinh muốn làm lại bài hay không

    // BNDung
    isAnswer: false, // khi click vào item bài làm hoặc lời giải thì field này để xác định
    questionAttachment: null,
    answerAttachment: null,
    correctAnswerAttachment: null,
    answerAttachments: [],
    correctAnswerAttachments: [],
    bothAttachment: [],
    summaryResults: {},
    questions: null,
    submitAnswer: 0,
    deadline: new Date(),
    isPreviewAnswer: true,
    status: 0,
    answerType: 0,
    note: '',
    studentExerciseID: '',
    exerciseDetailType: 0, // dạng bài tập chi tiết
    submitDetails: [], // lưu lại danh sách chi tiết bài tập ở bảng
    titleExercise: '',
    qtyQuestion: 0, // số lượng câu hỏi
    mainAttachment: null,
    nextStudent: false,
    answersEssay: [{
      SortOrder: 0,
      Content: '',
      Attachments: []
    }],

    // PBac
    oldStudentExerciseID: '',
    answerInHTML: '',
    isCancelNavigate: false,
    isNextStudent: false,
    isLastStudent: false,
    isDoUpdateStudentExercise: false,
    isChangeCorrecting: false,
    isSubmitCorrect: false, // biến dùng để lưu bài chữa hiện tại
    isSubmitNextStudent: false, // biến dùng để lưu bài chữa hiện tại và sang học sinh tiếp theo
    exerciseStatus: 0, // biến dùng để lưu trạng thái lưu bài
    isDeleteCorrect: false, // biến dùng để xóa bài chữa
    isSavingCorrect: false, // Biến kiểm soát dùng khi lưu bài chữa để hiển thị mask loading

    // dữ liệu đẩy vào chart trong màn hình dashboard giáo viên
    dataSubmitExerciseChart: null,
    isShowAnswer: false

  },

  getters: {
    submitStatus (state) {
      if (state.studentExercises.length > 0) {
        state.studentExercises.forEach((element) => {
          if (element.Status === Enumeration.StudentExerciseStatus.YetSubmit) {
            if (new Date(element.Deadline) < new Date()) {
              element.Status = Enumeration.StudentExerciseStatus.Expired
            } else {
              var diffDate =
                (new Date(element.Deadline) - new Date()) / (1000 * 3600 * 24)
              element.DiffDate = Math.ceil(diffDate)
            }
          }
        })
      }

      return {
        yetSubmit: state.studentExercises.filter(
          (item) => item.Status === Enumeration.StudentExerciseStatus.YetSubmit
        ).length,
        submited: state.studentExercises.filter(
          (item) => item.Status === Enumeration.StudentExerciseStatus.Submitted
        ).length,
        expired: state.studentExercises.filter(
          (item) => item.Status === Enumeration.StudentExerciseStatus.Expired
        ).length
      }
    },
    /**
     * Tổng số câu hỏi
     * @param {*} state
     * @returns
     */
    numberQuestion (state) {
      return state?.exerciseCard?.QtyQuestion
    },

    /**
     * Số lượng câu đã làm
     * @param {*} state
     * @returns
     */
    numberAnswers (state) {
      if (state.submitExercise.Questions?.length > 0) {
        const listAnswers = state.submitExercise.Questions
        var count = 0
        listAnswers.forEach(function (item) {
          if (item.Done) {
            count++
          }
        })
      }
      return count
    },

    /**
     * kiểm tra sẽ show màn hình preview hay màn compare
     */
    checkShowPreview (state) {
      if (state.answerType === Enumeration.AnswerType.Upload) {
        return true
      } else {
        return false
      }
    },

    /**
     * kiểm tra xem thử có được xem lời giải hay không ?
     */
    viewAnswers (state) {
      if (state.status === Enumeration.StudentExerciseStatus.Submitted || state.submitAnswer === 0 || new Date(state.deadline) > new Date()) {
        return true
      } else { return false }
    }
  },

  mutations: {
    /**
     * set giá trị cho câu tự luận
     * @param {} state
     * @param {*} param
     */
    setAnswersEssay (state, param) {
      // kiểm tra xem câu có đang tồn tại không ?
      const checkContain = state.answersEssay.find(x => {
        return x.SortOrder === param?.SortOrder
      })
      if (checkContain.length === 0) { // câu mới
        state.answersEssay.push(param)
      } else {
        state.answersEssay.map(item => {
          if (item.SortOrder === param.SortOrder) {
            item = { ...param }
          }
          return item
        })
      }
    },

    /**
     * @description hàm lưu lại thông tin hình ảnh + file up load khi sửa nhanh
     * @author BNDung
     * @param {*} state
     * @param {*} param
     */
    saveAttachmentExerciseCard (state, param) {
      state.exerciseCard.Questions[param.SortOrder - 1].Attachments = param.Attachments
    },

    /**
     * @description Hàm set xem đáp án hay không?
     * @author BNDung
     */
    setShowAnswer (state, param) {
      state.isShowAnswer = param
    },

    /**
     * @description hàm sửa câu hỏi
     * @author BNDung
     * @param {*} state
     * @param {*} params
     */
    editQuestion (state, question) {
      const objIndex = state.exerciseCard?.Questions.findIndex(x => x.SortOrder === question.SortOrder)
      state.exerciseCard.Questions[objIndex] = { ...question }
      // state.exerciseCard?.Questions.map(item => {
      //   if (item.SortOrder === question.SortOrder) {
      //     item = { ...question }
      //     return item
      //   }
      // })
    },

    /**
     * @description hàm sửa câu hỏi
     * @author BNDung
     * @param {*} state
     * @param {*} params
     */
    setActiveAnswer (state, params) {
      state.exerciseCard.Questions[params.questionSortOrder - 1].Answers[params.sortOrder - 1].active = true
    },

    /**
     * @description hàm set câu đúng sai cho câu hỏi dạng điền từ
     * @author BNDung
     * @param {*} state
     * @param {*} params
     */
    setCorrectAnswer (state, params) {
      state.exerciseCard.Questions[params.questionSortOrder - 1].Answers[params.sortOrder - 1].Correct = params.isCorrect
    },

    /**
       * @description hàm sửa câu hỏi
       * @author BNDung
       * @param {*} state
       * @param {*} params
       */
    setChoosedAnswer (state, SortOrder) {
        state.exerciseCard?.Questions.map(item => {
          if (item.SortOrder === SortOrder) {
            item.choosedAnswer = true
          }
          return item
        })
    },

    /**
       * Hàm đổi màu cho danh sách câu hỏi khi chọn đáp án
       */
    setResultQuestionType (state, param) {
      state.questions.map(item => {
        if (param.SortOrder === item.SortOrder) { item.ResultType = param.ResultType }
        return item
      })
    },

    /**
       * Hàm đổi màu cho câu trả lời đúng khi chọn đáp án
       */
    setResultAnswerType (state, param) {
      const answers = state.questions[param.SortOrder]
        answers?.map(item => {
          if (item.Correct === true) { item.ResultType = 'correct' }
        })
    },

    // cập nhật danh sách lớp theo học sinh
    setStudentExercise (state, studentExercises) {
      state.studentExercises = studentExercises
    },
    // cập nhật thông tin bài tập của học sinh
    setStudentExerciseByID (state, studentExercise) {
      state.studentExercise = studentExercise
    },

    /**
     * @description lấy dữ liệu cho chart
     * @author BNDung
     * @param {*} state
     * @param {*} dataSubmitExerciseChart
     */
    setDataSubmitExerciseChart (state, dataSubmitExerciseChart) {
      state.dataSubmitExerciseChart = dataSubmitExerciseChart
    },

    /**
     * @description cập nhật danh sách lớp theo học sinh
     * @author BNDung
     */
    setExerciseDetailType (state, exerciseDetailType) {
      state.exerciseDetailType = exerciseDetailType
    },

    /**
     * @description cập nhật danh sách lớp theo học sinh
     * @author BNDung
     */
    setSubmitExercise (state, submitExercise) {
      state.submitExercise = submitExercise
    },

    /**
     * @description set file lời giải
     * @param {*} state
     * @param {*} param
     */
    setAnswerAttachments (state, param) {
      // if (typeof param?.AnswerAttachment !== 'undefined' && param?.AnswerAttachment.length !== 0) {
      //   state.answerAttachment = param?.AnswerAttachment[0]
      // }
      state.answerAttachment = null
      state.answerAttachments = param
    },

    /**
     * @description cập nhật thông tin file prevew file
     * @author BNDung
     *  */
    setPreviewAttachment (state, param) {
      if (typeof param?.AnswerAttachment !== 'undefined') {
        state.mainAttachment = param?.AnswerAttachment[0]
      }
      if (typeof param.CorrectAnswerAttachment !== 'undefined' &&
        param?.AnswerAttachment.length !== 0) {
        state.bothAttachment = param?.CorrectAnswerAttachment[0]
        state.isAnswer = true
      } else if (state.bothAttachment.length === 0 && typeof param?.QuestionAttachment !== 'undefined' &&
      param?.CorrectAnswerAttachment?.length !== 0) {
        state.bothAttachment = param?.QuestionAttachment
      }

      // thêm đề bài
      if (
        typeof param?.QuestionAttachment !== 'undefined' &&
        param?.QuestionAttachment.length !== 0
      ) {
        state.questionAttachment = param?.QuestionAttachment
      }

      // thêm đáp án
      if (
        typeof param?.AnswerAttachment !== 'undefined' &&
        param?.AnswerAttachment.length !== 0
      ) {
        state.answerAttachment = param?.AnswerAttachment[0]
        state.answerAttachments = param?.AnswerAttachment
      }

      // thêm lời giải
      if (
        typeof param?.CorrectAnswerAttachment !== 'undefined' &&
        param?.CorrectAnswerAttachment.length !== 0
      ) {
        state.correctAnswerAttachment = param?.CorrectAnswerAttachment[0]
        state.correctAnswerAttachments = param?.CorrectAnswerAttachment
      }

      state.questions = param?.Questions
      state.correctAnswerNote = param?.CorrectAnswerNote
      // set state summarry để lấy số lượng câu trả lời đúng, sai, chưa làm
      state.summaryResults = param?.SummaryResults
      state.submitAnswer = param?.SubmitAnswer
      state.deadline = param?.Deadline

      state.status = param?.Status
      state.answerType = param?.AnswerType
      state.note = param?.Note
      state.studentExerciseID = param?.StudentExerciseID
      if (typeof param?.SubmitDetail !== 'undefined') {
        state.submitDetails = param?.SubmitDetail
      }
      state.titleExercise = param?.Title
      state.studentExercise.RefAttachment = param?.RefAttachment
    },

    // thực hiện thay đổi lời giải khi click vào file
    setCorrectAnswerAttachment (state, param) {
      state.correctAnswerAttachment = param
    },

    // thực hiện thay đổi lời giải khi click vào file
    setAnswerAttachment (state, param) {
      state.answerAttachment = param
    },

    // show màn hình preview answer theo dữ liệu
    setPreviewAnswer (state, param) {
      state.isPreviewAnswer = param
    },

    // cập nhật câu hỏi được chọn
    setSelectedQuestion (state, sortOrder) {
      state.selectedQuestion = null

      const tmpQuestion = state.exerciseCard?.Questions.find(
        (item) => item.SortOrder === sortOrder
      )
      const tmpSubmit = state.submitExercise?.Questions.find(
        (item) => item.SortOrder === sortOrder
      )

      tmpSubmit?.Answers.forEach(function (item) {
        tmpQuestion?.Answers.forEach(function (question) {
          if (item.SortOrder === question.SortOrder) {
            question.Correct = item.Correct
            question.ContentAnswer = item.Content
            question.Image = item.Image
          }
        })
      })
      state.selectedQuestion = {
        Type: tmpQuestion?.Type,
        Content: tmpQuestion?.Content,
        SortOrder: tmpQuestion?.SortOrder,
        Attachments: tmpQuestion?.Attachments,
        Done: tmpSubmit?.Done,
        Hint: tmpQuestion?.Hint,
        Answers: tmpQuestion?.Answers,
        Owner: state.exerciseCard?.Owner,
        MappingAnswer: tmpQuestion.MappingAnswer,
        choosedAnswer: tmpQuestion?.choosedAnswer || false,
        active: tmpQuestion.active
      }
    },
    // cập nhật câu trả lời cho câu hỏi
    updateAnswerForQuestion (state, param) {
      const tmpSubmit = state.submitExercise?.Questions.filter(
        (item) => item.SortOrder === param.sortOrderQuestion
      )
      // Đối với dạng câu hỏi Yes/No
      if (tmpSubmit[0].Type === Enumeration.QuestionType.Yesorno) {
        tmpSubmit[0].Answers.forEach(function (item) {
          if (item.SortOrder === param.sortOrderAnswer) {
            item.Correct = !item.Correct
          } else {
            item.Correct = false
          }
        })
      }

      // Đối với dạng câu hỏi chọn nhiều đáp án
      if (tmpSubmit[0].Type === Enumeration.QuestionType.Select) {
        tmpSubmit[0].Answers.forEach(function (item) {
          if (item.SortOrder === param.sortOrderAnswer) {
            item.Correct = !item.Correct
          }
        })
      }

      // // Đối với dạng câu hỏi chọn 1 đáp án
      // if (tmpSubmit[0].Type === Enumeration.QuestionType.Select) {
      //   tmpSubmit[0].Answers.forEach(function (item) {
      //     if (item.SortOrder === param.sortOrderAnswer) {
      //       item.Correct = !item.Correct
      //     } else {
      //       item.Correct = false
      //     }
      //   })
      // }

      // Đối với dạng câu hỏi điền từ vào chỗ trống
      if (tmpSubmit[0].Type === Enumeration.QuestionType.Fill) {
        tmpSubmit[0].Answers.forEach(function (item) {
          if (item.SortOrder === param.sortOrderAnswer) {
            item.Content = param.contentAnswer
            if (param.contentAnswer !== '') {
              item.Correct = true
            } else {
              item.Correct = false
            }
          }
        })
      }

      // Đối với dạng câu hỏi tự luận
      if (tmpSubmit[0].Type === Enumeration.QuestionType.Essay) {
        tmpSubmit[0].Answers.forEach(function (item) {
          if (item.SortOrder === param.sortOrderAnswer) {
            item.Content = param.contentAnswer
            if (param.contentAnswer !== '') {
              item.Correct = true
            } else {
              item.Correct = false
            }
          }
        })
      }
      tmpSubmit[0].Done = false
      // Set lại trạng thái câu hỏi đã được trả lời hay chưa
      tmpSubmit[0].Answers.forEach(function (item) {
        if (item.Correct === true) {
          tmpSubmit[0].Done = true
        }
      })
    },

    /**
     * @description set null question khi load bài làm thử
     * @param {*} state
     */
    setNullQuestion (state) {
      state.questions = null
    },

    // clone dữ liệu câu hỏi sang param submit để nộp bài
    cloneExerciseCardToSubmitExercise (state, exerciseCard) {
      state.exerciseCard = []
      state.questions = []
      state.submitExercise = null

      state.exerciseCard = exerciseCard
      if (exerciseCard.id === null || typeof exerciseCard.id === 'undefined') {
        state.exerciseCard.QtyQuestion = exerciseCard.Questions.length
      }

      state.submitExercise = {
        SubmitExerciseID: state.exerciseSaveDraft,
        ExerciseCardID: exerciseCard.ExerciseCardID,
        StudentExerciseID: exerciseCard.StudentExerciseID,
        Note: exerciseCard.Note,
        Status: 0,
        Replay: exerciseCard.Replay,
        Questions: []
      }
      exerciseCard?.Questions.forEach(function (question) {
        var questionSubmit = {
          Type: question.Type,
          SortOrder: question.SortOrder,
          Done: question.Done,
          Answers: [],
          MappingAnswer: question.MappingAnswer
        }
        question.Answers.forEach(function (item) {
          var answer = {
            Correct: item.Correct,
            Content: item.Content,
            Image: item.Image,
            SortOrder: item.SortOrder
          }
          questionSubmit?.Answers.push(answer)
        })
        state.questions.push(questionSubmit)
        // state.submitExercise.Questions
      })
    },
    updateStatusSubmitExercise (state, status) {
      state.submitExercise.Status = status
    },
    // Cập nhật số lượng bài tập theo từng loại
    updateCountExercise (state, countExercise) {
      state.countExercise = countExercise
    },
    // Cập nhật tab đang được active
    updateTabActive (state, tabActive) {
      if (tabActive != null) {
        state.tabActive = tabActive
      } else {
        state.tabActive = 0
      }
    },
    // Cập nhật tab đang được active
    updateTabActiveClassroom (state, tabActiveClassroom) {
      if (tabActiveClassroom != null) {
        state.tabActiveClassroom = tabActiveClassroom
      } else {
        state.tabActiveClassroom = 0
      }
    },
    // cập nhật ghi chú
    updateNoteExercise (state, noteExercise) {
      state.submitExercise.Note = noteExercise
    },
    // Cập nhật ID bài lưu nháp và trạng thái làm tiếp theo
    updateSubmitExerciseSaveDraft (state, params) {
      state.exerciseSaveDraft = params.SubmitExerciseID
      state.isReplay = params.IsReplay
    },
    // Cập nhật ID bài lưu nháp
    updateSubmitExerciseId (state, submitExerciseId) {
      state.submitExercise.SubmitExerciseID = submitExerciseId
    },
    // cập nhật ID bài tập của học sinh
    updateStudentExerciseID (state, id) {
      if (state.studentExerciseID === '') {
        state.oldStudentExerciseID = id
      } else {
        state.oldStudentExerciseID = state.studentExerciseID
      }
      state.studentExerciseID = id
    },

    /**
     * khởi tạo html dạng string để truyền vào control
     * @param {*} state
     * @param {*} param
     * @author PBac
     */
    setAnswerInHTML (state, param) {
      state.answerInHTML = param
    },

    /**
     * mutation để cập nhật lại nhận xét của bài làm học sinh
     * @param {*} state
     * @param {*} param
     * @author PBac
     */
    updateStudentExerciseComment (state, param) {
      state.studentExercise.Mark.Comment = param
    },

    /**
     * mutation để cập nhật lại isCancelNavigate
     * @param {*} state
     * @param {*} param
     * @author PBac
     */
    updateCancelNavigate (state) {
      state.isCancelNavigate = !state.isCancelNavigate
    },

    /**
     * mutation để cập nhật lại isNextStudent
     * @param {*} state
     * @author PBac
     */
    updateIsNextStudent (state) {
      state.isNextStudent = !state.isNextStudent
    },

    /**
     * mutation cập nhật state isLastStudent
     * @param {*} state
     * @param {*} param
     * @author PBac
     */
    updateIsLastStudent (state, param) {
      state.isLastStudent = param
    },

    /**
     * mutation cập nhật state để cập nhật bài chữa của giáo viên
     * @param {*} state
     * @param {*} param
     * @author PBac
     */
    updateIsDoUpdateStudentExercise (state, param) {
      state.isDoUpdateStudentExercise = param
    },

    /**
     * mutation cập nhật state kiểm tra dữ liệu thay đổi (giáo viên đã thực hiện thao tác nào chưa)
     * @param {*} state
     * @param {*} param
     * @author PBac
     */
    updateIsChangeCorrecting (state, param) {
      state.isChangeCorrecting = param
    },

    // set bài làm
    setIsAnswer (state, param) {
      state.isAnswer = param
    },

    // thay đổi bài làm trên preview
    setMainAttachment (state, mainAttachment) {
      state.mainAttachment = mainAttachment
    },

    // thực hiện thay đổi lời giải và bài làm khi click vào file
    setBothAttachment (state, param) {
      state.bothAttachment = param
    },
    // thực hiện lưu file thông tin
    setFileInformation (state, fileInformation) {
      state.fileInformation = fileInformation
    },

    // thực hiện lưu và tiếp tục
    setNextStudent (state) {
      state.nextStudent = !state.nextStudent
    },

    // Cập nhật state để lưu bài và trạng thái (lưu nháp/hoàn thành)
    updateOnClickOption (state, exerciseStatus) {
      state.isSubmitCorrect = !state.isSubmitCorrect
      state.exerciseStatus = exerciseStatus
    },

    updateIsSubmitNextStudent (state) {
      state.isSubmitNextStudent = !state.isSubmitNextStudent
    },

    updateIsDeleteCorrect (state) {
      state.isDeleteCorrect = !state.isDeleteCorrect
    },

    // Cập nhật state lưu bài chữa để hiển thị mask loading
    updateIsSavingCorrect (state, isSavingCorrect) {
      state.isSavingCorrect = isSavingCorrect
    }
  },

  actions: {
    /**
     * Đẩy dữ liệu vào pewview câu trả lời
     * @param {*} context
     * @param {*} param
     */
    getAnswerAttachment (context, param) {
      context.commit('setAnswerAttachment', param)
    },

    /**
     * Đẩy dữ liệu vào pewview câu trả lời
     * @param {*} context
     * @param {*} param
     */
    getCorrectAnswerAttachment (context, param) {
      context.commit('setCorrectAnswerAttachment', param)
    },

    /**
     * Show màn hình preview answer hoặc compare answer
     * @param {*} context
     * @param {*} param
     */
    getPreviewAnswer (context, param) {
      context.commit('setPreviewAnswer', param)
    },

    /**
     * Lấy dữ liệu các file preview từ giáo viên chấm điểm
     * @author BNDung
     * @param {*} context
     * @param {*} param
     */
    getPreviewAttachmentTeacher (context, param) {
      return new Promise((resolve, reject) => {
        ExerciseCardAPI.getAsync(`grade-submit-exercise/${param}`).then((res) => {
          context.commit('setPreviewAttachment', res.Data)
        }).catch(err => {
          reject(err)
        })
      })
    },

    /**
     * Lấy dữ liệu đẩy lên chart nộp bài chưa nộp, đúng sai chưa làm
     * @author BNDung
     * @param {*} context
     * @param {*} param
     */
    async getDataSubmitExerciseChart (context, param) {
      const res = await DashboardAPI.getAsync('data-submit-exercise-chart', { params: param })
      return res.Data
    },

    /**
     * @description Lấy danh sách bài tập học sinh
     * @author NVHUY1
     * @param {*} context
     * @param {*} studentExercises
     * @returns
     */
    getStudentExercises (context, param) {
      return new Promise((resolve, reject) => {
        ExerciseCardAPI.getAsync(
          `/exercise-studentid?Type=${param.Type}&TextSearch=${param.TextSearch}&Skip=${param.Skip}&Take=${param.Take}&ClassCode=${param.ClassCode}`
        )
          .then((res) => {
            context.commit('setStudentExercise', res.Data)

            resolve(true)
          })
          .catch((err) => {
            reject(err)
          })
      })
    },

    /**
     * @description Lấy dữ liệu bài tập học sinh theo Id và theo lớp
     * @author NVHUY1
     * @param {*} context
     * @param {*} studentExercises
     * @returns
     */
    getCountExercise (context, classCode) {
      return new Promise((resolve, reject) => {
        ExerciseCardAPI.getAsync(`/count?ClassCode=${classCode || ''}`)
          .then((res) => {
            context.commit('updateCountExercise', res.Data)
            resolve(true)
          })
          .catch((err) => {
            reject(err)
          })
      })
    },

    /**
     * @description Lấy dữ liệu bài tập học sinh theo Id và theo lớp
     * @author NVHUY1
     * @param {*} context
     * @param {*} studentExercises
     * @returns
     */
    getExerciseByIDAndClassCode (context, params) {
      return new Promise((resolve, reject) => {
        ExerciseCardAPI.getAsync(`/classroom-exercise/${params}`)
          .then((res) => {
            context.commit('setStudentExercise', res.Data)
            resolve(true)
          })
          .catch((err) => {
            reject(err)
          })
      })
    },
    /**
     * Thực hiện chọn câu hỏi
     * @param {*} context
     * @param {*} params
     */
    setSelectdQuestionBySortOrder (context, params) {
      context.commit('setSelectedQuestion', params)
    },
    /**
     * Cập nhật đáp án cho từng câu hỏi
     * @param {*} context
     * @param {*} params
     */
    updateAnswerForQuestion (context, params) {
      context.commit('updateAnswerForQuestion', params)
      context.commit('setSelectedQuestion', params.sortOrderQuestion)
    },
    /**
     * @description Hiện tại chưa có API nên fix dữ liệu khi mới vào màn hình mặc định chọn câu hỏi đầu tiên
     * @author NVHUY1
     * @param {*} context
     * @param {*} studentExercises
     * @returns
     */
    getStudentExerciseByIDAndClassCode (context, params) {
      // Convert dữ liệu trả về sang param lưu
      return new Promise((resolve, reject) => {
        ExerciseCardAPI.getAsync(
          `/submit-exercise?studentExerciseID=${params.StudentExerciseID}&submitExercisesID=${params.SubmitExercisesID}&isReplay=${params.IsReplay}`
        )
          .then((res) => {
            if (res.Data) {
              context.commit('cloneExerciseCardToSubmitExercise', res.Data)
              context.commit('setSelectedQuestion', 1)
            }
            resolve(true)
          })
          .catch((err) => {
            reject(err)
          })
      })
    },

    getStudentExerciseByExerciseCard (context, params) {
      if (params) {
        context.commit('cloneExerciseCardToSubmitExercise', params)
        context.commit('setSelectedQuestion', 1)
      }
    },

    /**
     * Cập nhật trạng thái bài nộp là lưu nháp hay nộp bài
     * @param {*} context
     * @param {*} status
     */
    updateStatusSubmitExercise (context, status) {
      context.commit('updateStatusSubmitExercise', status)
    },
    /**
     * @description hàm submit exercise
     * @param {*} context
     * @param {*} exerciseStoreField
     * @returns
     */
    submitStudentExercise (context, submitExercise) {
      return new Promise((resolve, reject) => {
        ExerciseCardAPI.postAsync('/SubmitExercise', submitExercise)
          .then((res) => {
            resolve(res)
          })
          .catch((err) => {
            reject(err)
          })
      })
    },
    /**
     * Cập nhật thông tin tab đang active
     * @param {*} context
     * @param {*} params
     */
    updateTabActive (context, params) {
      context.commit('updateTabActive', params)
    },
    /**
     * Cập nhật thông tin tab đang active bên lớp học
     * @param {*} context
     * @param {*} params
     */
    updateTabActiveClassroom (context, params) {
      context.commit('updateTabActiveClassroom', params)
    },
    /**
     * Cập nhật thông tin tab đang active
     * @param {*} context
     * @param {*} params
     */
    updateNoteExercise (context, noteExercise) {
      context.commit('updateNoteExercise', noteExercise)
    },
    /**
     * @description hàm submit exercise
     * @param {*} context
     * @param {*} exerciseStoreField
     * @returns
     */
    getSubmitExerciseById (context, submitExercisesID) {
      return new Promise((resolve, reject) => {
        ExerciseCardAPI.postAsync(`submit-exercise/${submitExercisesID}`)
          .then((res) => {
            context.commit('setSubmitExercise', res.Data)
            resolve(res)
          })
          .catch((err) => {
            reject(err)
          })
      })
    },
    /**
     * @description Sửa trạng thái của học sinh
     * @author NTQuy
     * @param {*} context
     * @param {*} classroom
     * @returns
     */
    updateNoteExerciseById (context, params) {
      const bodyUpdate = {
        Id: params.StudentExerciseID,
        Note: params.Note,
        UpdateFields: ['Note']
      }
      return new Promise((resolve, reject) => {
        ExerciseCardAPI.putAsync(`/${params.StudentExerciseID}`, bodyUpdate)
          .then((res) => {
            resolve(res)
          })
          .catch((err) => {
            reject(err)
          })
      })
    },
    // cập nhật id submitexercise lưu nháp
    updateSubmitExerciseSaveDraft (context, params) {
      context.commit('updateSubmitExerciseSaveDraft', params)
    },

    /**
     * Lấy dữ liệu các file preview từ học sinh làm bài
     * @author BNDung
     * @param {*} context
     * @param {*} submitExercisesID
     */
    getPreviewAttachmentStudent (context, params) {
      return new Promise((resolve, reject) => {
        ExerciseCardAPI.getAsync(
          `preview-submit-exercise?studentExerciseID=${params.studentExercisesID}&submitExercisesID=${params.submitExercisesID}`
        )
          .then((res) => {
            context.commit('setPreviewAttachment', res.Data)
          })
          .catch((err) => {
            reject(err)
          })
      })
    },

    /**
     * Cập nhật SubmitExerciseId sau khi lưu nháp thành công
     */
    updateSubmitExerciseId (context, submitExercisesID) {
      context.commit('updateSubmitExerciseId', submitExercisesID)
    },

    /**
     * Cập nhật trạng thái bài nộp là lưu nháp hay nộp bài
     * @param {*} context
     * @param {*} status
     */
    async setResultQuestionType (context, param) {
      await context.commit('setResultQuestionType', param)
    },

    /**
     * @description Cập nhật thêm trường thông tin Mark khi giáo viên chấm bài
     * @author PBac
     * @param {*} params
     * @returns
     */
    updateStudentExercise (context, params) {
      return new Promise((resolve, reject) => {
        StudentExerciseAPI.putAsync(`${params.Id}`, params)
          .then((res) => {
            resolve(res)
          })
          .catch((err) => {
            reject(err)
          })
      })
    },

    getStudentExerciseByID (context, StudentExerciseID) {
      return new Promise((resolve, reject) => {
        StudentExerciseAPI.getAsync(`${StudentExerciseID}`)
          .then((res) => {
            context.commit('setStudentExerciseByID', res.Data)
            resolve(res)
          })
          .catch((err) => {
            reject(err)
          })
      })
    },

    /**
     * @description Sửa trạng thái bài tập tham khảo
     * @author BNDung
     * @param {*} context
     * @param {*} classroom
     * @returns
     */
    updateIsReferExerciseById (context, params) {
      return new Promise((resolve, reject) => {
        StudentExerciseAPI.putAsync(`/update-is-reference?classID=${params.ClassID}&isReference=${params.IsRefer}`)
          .then((res) => {
            resolve(res)
          })
          .catch((err) => {
            reject(err)
          })
      })
    }
  }
}
